module.exports = __webpack_public_path__ + "img/la.445a9170.svg";